import clsx from 'clsx';
import React from 'react';

import DeepResearchSuggested from '../AI/DeepResearch/Suggested';

interface DeepResearchPromoProps {
  isDeepResearchActive: boolean;
  setSuggestedPrompt: (prompt: string) => void;
}

const DeepResearchPromo = ({
  isDeepResearchActive,
  setSuggestedPrompt,
}: DeepResearchPromoProps) => {
  return (
    <div
      className={clsx('mt-40 overflow-hidden transition-all duration-300 ease-in-out sm:mt-72', {
        'max-h-full translate-y-0 opacity-100': isDeepResearchActive,
        '!mt-0 max-h-0 -translate-y-2 opacity-0': !isDeepResearchActive,
      })}
    >
      <p className="my-0 font-suisse-neue text-body-md text-grayscale-charcoal sm:text-body-lg">
        I am trained on The Information’s exclusive reporting and data. Try asking me to…
      </p>
      <DeepResearchSuggested
        disablePrompts={!isDeepResearchActive}
        setSuggestedPrompt={setSuggestedPrompt}
        hideLoader={true}
      />
    </div>
  );
};

export default DeepResearchPromo;
